module.exports = __webpack_public_path__ + "static/media/bgLayout.1d7c6ad8.svg";